let date = new Date();
let dateY = new Date();
dateY.setFullYear(dateY.getFullYear()+1);
export default {
    Id: '',
    Number: '',
    IssueDate: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    StartDate: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    EndDate: '' + (dateY.getDate() > 9 ? '' : '0') + dateY.getDate() + '.' + (dateY.getMonth() > 8 ? '' : '0') + (dateY.getMonth() + 1) + '.' + dateY.getFullYear(),
    ContragentId: '',
    PartnerLegalId: '',
    ContragentName: '',
    ContragentType: '',
    OwnerLegalEntityId: '',
    CurrencyId: 1,
    Type: 1,
    IsPayed: false,
    IsUsed: false,
    Sum: 0,
    options:{
        contragentLegals:[],
    },
    rules:{
        Number: [
            {required: true, message: 'Введите номер сертификата', trigger: 'blur,change'},
        ],
        ContragentId: [
            {required: true, message: 'Выберите покупателя', type: 'number', trigger: 'blur,change'},
        ],
        Sum: [
            {required: true, min:1, message: 'Введите сумму сертификата', type: 'number', trigger: 'change'},
        ],
        OwnerLegalEntityId: [
            {required: true, message: 'Выберите фирму-владелеца', type: 'number', trigger: 'blur,change'},
        ],
    }
}